//region block: pre-declaration
//endregion
function _B0___init__impl__6otxhp(b0) {
  return b0;
}
function _B0___get_b0__impl__g161pk($this) {
  return $this;
}
//region block: exports
export {
  _B0___init__impl__6otxhp as _B0___init__impl__6otxhp3kdufm9pjbwxq,
  _B0___get_b0__impl__g161pk as _B0___get_b0__impl__g161pk2r1aexc5wbrr2,
};
//endregion

//# sourceMappingURL=-EndianUtils.mjs.map
